module.exports = __webpack_public_path__ + "static/img/lannd-bg-blue.86985b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lannd-bg-blue.png
// module id = CZsb
// module chunks = 0